import * as React from 'react'
import * as PropTypes from 'prop-types'

Feature.propTypes = {
  flag: PropTypes.string,
  username: PropTypes.string,
  children: PropTypes.any
}

const STATS = 'STATS'

const enabledFlags = (username) => new Set([
  ...(username === 'blueshirts' || username === 'xtremeflyerscoach' ? [STATS] : [])
])

export default function Feature (props) {
  const {
    flag,
    username,
    children
  } = props

  return enabledFlags(username).has(flag) ? <>{children}</> : null
}

Object.defineProperty(Feature, STATS, {
  value: STATS,
  configurable: false,
  enumerable: false,
  writable: false
})
